import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const HalfAdderFullAdder = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Half Adder, Full Adder"
    videos={[
      "https://www.youtube.com/embed/5XbRIVWFRIw?si=CMx3t24y_EX6SzP1",
      "https://www.youtube.com/embed/YIjrF4CoMik?si=ohoNFTDbVQDlOuMA"
    ]}
    takeaways={[
      {text:"Practice or copy all the answers of morris mano practice problems in the notebook, direct or similar questions may come in exam (both cat2 and fat)."},
      {text:"Dr. Dhiman (Learn the art of problem solving) - search for this youtube channel, he provided solutions for many problems in morris mano."},
      {text:"Refer to playlist: https://youtube.com/playlist?list=PLI0y8_sKQPD991sipHcqWNOJ0nmCnqPSw&si=3UiykIHYaHnWmlvp"}
    ]}
    questions={[
      "1) Design a combinational circuit with Full-adders and logic gates. The circuit produces the output as 5 times of its input. The size of input is 3 bits.",
      "2) Design a combinational circuit whose output (F) is equal to 1 if the three input variables have more 1’s than 0’s. The output is 0 otherwise. Assume three inputs, x, y, and z. (i) Implement the above circuit using logic gates and (ii) using 1x8 De-Multiplexer which is constructed using two 1X4 De-Multiplexer",
      "3) Design Full adder and Full Subtractor using MUX. Write the mixed style Verilog code and test bench with line by line comments for Full subtractor implementation using MUX.",
      "4) Implement 1:4 De-Multiplexer circuit using logic gates. Design a Combinational circuit with three inputs, x, y, and z, and three outputs, A, B, and C, in which the binary output is one greater than the input if the input is 0, 1, 2, or 3, else binary output is two less than the input using only De-Multiplexer and logic gates. Show the internal circuit of 1:8 DEMUX using 1:4 DEMUX with investors. Write the mixed style Verilog code and test bench with line by line comments of the above Design.",
      "5) The circuit has 3 bit binary inputs (A2,A1,A0) and their 2's complement as output (D2,D1,D0). Write its truth table and then design using full adder."
    ]}
    exampleVideos={[]}
  />
);
}

export default HalfAdderFullAdder;
